import { render, staticRenderFns } from "./PsnStatutoryEdit.vue?vue&type=template&id=feb5b16e"
import script from "./PsnStatutoryEdit.vue?vue&type=script&lang=js"
export * from "./PsnStatutoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports